import { jsonrepair } from "jsonrepair";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function safeJsonParse(jsonString: string, fallback?: any): any {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    const repaired = jsonrepair(jsonString);
    try {
      return JSON.parse(repaired);
    } catch (error) {
      console.error("Failed to parse JSON from the second try:", error);
      if (fallback) return fallback;
      throw error;
    }
  }
}
